import { PledgeStatus } from 'constants/pledges';
import { twMerge } from 'tailwind-merge';

const PledgeStatusIndicator = ({
    value,
    children,
}: {
    value: PledgeStatus;
    children?: React.ReactNode;
}) => {
    const statusClass = {
        [PledgeStatus.Canceled]: 'bg-red-50 text-red-500',
        [PledgeStatus.Fulfilled]: 'bg-green-50 text-green-500',
        [PledgeStatus.OffSchedule]: 'bg-orange-50 text-orange-500',
        [PledgeStatus.OnSchedule]: 'bg-blue-50 text-blue-500',
    }[value];

    const label = {
        [PledgeStatus.Canceled]: 'Canceled',
        [PledgeStatus.Fulfilled]: 'Fulfilled',
        [PledgeStatus.OffSchedule]: 'Off schedule',
        [PledgeStatus.OnSchedule]: 'On schedule',
    }[value];

    return (
        <div
            className={twMerge(
                `flex items-center gap-1 rounded-full px-2 py-1 text-xs font-medium`,
                statusClass,
            )}
        >
            {label} {children}
        </div>
    );
};

export { PledgeStatusIndicator };
